import { Component } from '@angular/core';

@Component({
  selector: 'app-call-to-action-section2',
  standalone: true,
  imports: [],
  templateUrl: './call-to-action-section2.component.html',
  styleUrl: './call-to-action-section2.component.scss'
})
export class CallToActionSection2Component {

}
